import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateOffset',
})
export class DateOffsetPipe implements PipeTransform {
  transform(value: Date, offsetMinutes: number): Date {
    const offset = new Date(value);
    offset.setMinutes(offset.getMinutes() + offsetMinutes);
    return offset;
  }
}
